import BackendService from './BackendService';

export default class DealService {
  static getAnnouncements() {
    return BackendService.get('/announcements/all');
  }

  static getAnnouncement(announcementId) {
    return BackendService.get(`/announcements/${announcementId}`);
  }

  static createAnnouncement(announcement) {
    return BackendService.post('/announcements/', {
      body: announcement,
    });
  }

  static updateAnnouncement(announcement) {
    return BackendService.put(`/announcements/${announcement.id}`, {
      body: announcement,
    });
  }

  static deleteAnnouncement(announcementId) {
    return BackendService.delete(`/announcements/${announcementId}`);
  }
}
